import { render, staticRenderFns } from "./WorkBookActionMenu.vue?vue&type=template&id=d33240fe&scoped=true&"
import script from "./WorkBookActionMenu.vue?vue&type=script&lang=js&"
export * from "./WorkBookActionMenu.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookActionMenu.vue?vue&type=style&index=0&id=d33240fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33240fe",
  null
  
)

export default component.exports